// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"782":"298ea79a","952":"97689fda"}[chunkId] + ".chunk.js";
};